import { ICriteria } from "./interfaces/candidatesListFace";
import { TemplateTypes } from "../../shared/utils/interfaces/settingsInterface"
import { IBlog } from "./interfaces/blogPageFace";
import { getImageUrl } from "./functions/images";
import { CTAType, ILandingPageContent } from "./interfaces/landingPageFace";
import { QuestionTypes } from "./interfaces/applyToJobFace";

export const baseUrl = 'https://api.peoplecq.com/'; // ENABLE ON PROD
// export const baseUrl = 'https://dev.api.workimize.com/';

export const filesBaseUrlProd = 'https://peoplecq-metadata-prod.s3.us-west-1.amazonaws.com';
export const filesBaseUrlDev = 'https://peoplecq-metadata.s3.eu-south-1.amazonaws.com';

export const assetsBaseUrl = 'https://peoplecq-frontend-assets.s3.us-west-1.amazonaws.com/assets/';
export const landingPageDir = 'landingPage/';

export const serverTypes = {
    dev: 'dev/'
}

export const validationMsgs = {
    invalidEmail: 'Not a valid email address',
    invalidUrl: 'Not a valid URL',
    invalidPhone: 'Not a valid phone number'
}

export const employmentTypes = [
    {
        value: 'fullTime',
        name: 'Full-time'
    },
    {
        value: 'partTime',
        name: 'Part-time'
    },
    {
        value: 'temporary',
        name: 'Temporary'
    }
];
export const jobTypes = [
    {
        value: 'onsite',
        name: 'On-Site'
    },
    {
        value: 'hybrid',
        name: 'Hybrid'
    },
    {
        value: 'remote',
        name: 'Remote'
    },
];

export enum apiStatuses {
    success = 200,
    success201 = 201,
    signupSuccess = 201,
    processingRequest = 202,
    notFound = 404,
    badRequest = 400,
    serverError = 500,
    serverTimeOut = 504,
    connectionTimeOut = 408,
    conflict = 409,
    TooManyRequest = 425,
    unAuthorized = 401,
    requestsLimit = 429,
    requestsLocked = 406,
    requestForbidden = 403,
    serverFailedProcessing = 422
}
export const rephraseList = [
    {
        label: 'Make Shorter', key: 5,
    },
    {
        label: 'Make Longer', key: 4,
    },
    {
        label: 'Correct Sentence', key: 3,
    },
]
export const hiringStages = [
    {
        label: 'Send to ShortList', key: 1,
    },
    {
        label: 'Send to Assessment', key: 2,
    },
    {
        label: 'Send to Interview', key: 3,
    },
    {
        label: 'Send an Offer', key: 4,
    },
    {
        label: 'Hire Candidate', key: 5,
    }
]
export enum actions {

    regenerate = 1,

    changeTone = 2,

    correctSentence = 3,
    makeLonger = 4,
    makeShorter = 5,

    convertToBullets = 6,

    convertToParagraph = 7
}
export enum actionsName {
    regenerate = 'regenerate',
    changeTone = 'changeTone',
    useContent = 'useContent',
    rephrase = 'rephrase',
    toggle = 'toggle'
}
export const errorMessage = 'Something went wrong';
export const errorMessageAI = "Something went wrong generating content!";
export const removePipelineErrorMessage = 'Can’t remove! This hiring stage contains candidates'
export enum userNavigationActions {
    setting = 'Settings',
    logOut = 'Logout',
    myPage = 'Visit Career Portal'
}
export const userNavigation = [
    { name: userNavigationActions.setting },
    { name: userNavigationActions.logOut },
]


export enum tagTypes {
    job = 'Job',
    jobs = 'Jobs',
    user = 'User',
    candidates = "Candidates",
    candidate = 'Candidate',
    members = 'Members',
    comments = 'Comments',
    domainConfig = 'Domain Config',
    aiSearch = "aiSearch",
    templates = 'templates',
    automatedActions = 'automatedActions',
    search = 'search',
    departments = 'departments',
    similarity = 'similarity'
}

export const enum sampleDataStatusId {
    created = 3,
    failed = 4
}

export const supportedMail = 'support@peoplecq.com';
export const refundMail = 'refunds@peoplecq.com';
export const roleError = 'You don’t have access, please contact the admin'

export const breakpoints = {
    // Min width
    'min-screen-sm': 576,
    'min-screen-md': 768,
    'min-screen-lg': 992,
    'min-screen-xl': 1200,
    'min-screen-2x': 1366,
    'min-screen-3x': 1601,
    'min-screen-4x': 1921,

    // Max width
    'max-screen-sm': 767,
    'max-screen-md': 991,
    'max-screen-lg': 1199,
    'max-screen-xl': 1365,
    'max-screen-2x': 1600,
    'max-screen-3x': 1920,
    'max-screen-4x': 2800,

    // Mobile breakpoints
    'max-mobile-xs': 479,
    'max-mobile-mini': 575,
    'max-mobile-sm': 580,
}
export const mockCriteriaSummary = "Justification for this score is being generated.."
export const criteriaMockData: ICriteria[] = [
    {
        applicationId: 1,
        id: 1,
        jobCriteria: {
            criteriaName: "Certifications",
            id: 1,
            isMain: true,
            jobId: 1,
        },
        jobCriteriaId: 1,
        score: "NA",
        summary: mockCriteriaSummary,
        longSummary: mockCriteriaSummary
    },
    {
        applicationId: 1,
        id: 1,
        jobCriteria: {
            criteriaName: "Leadership",
            id: 1,
            isMain: true,
            jobId: 1,
        },
        jobCriteriaId: 1,
        score: "NA",
        summary: mockCriteriaSummary,
        longSummary: mockCriteriaSummary
    },
    {
        applicationId: 1,
        id: 1,
        jobCriteria: {
            criteriaName: "Adaptability",
            id: 1,
            isMain: true,
            jobId: 1,
        },
        jobCriteriaId: 1,
        score: "NA",
        summary: mockCriteriaSummary,
        longSummary: mockCriteriaSummary
    },
    {
        applicationId: 1,
        id: 1,
        jobCriteria: {
            criteriaName: "Teamwork",
            id: 1,
            isMain: true,
            jobId: 1,
        },
        jobCriteriaId: 1,
        score: "NA",
        summary: mockCriteriaSummary,
        longSummary: mockCriteriaSummary
    },
    {
        applicationId: 1,
        id: 1,
        jobCriteria: {
            criteriaName: "Time Management",
            id: 1,
            isMain: true,
            jobId: 1,
        },
        jobCriteriaId: 1,
        score: "NA",
        summary: mockCriteriaSummary,
        longSummary: mockCriteriaSummary
    }
]

export const templatesTypesData = [
    {
        key: TemplateTypes.email,
        label: "Email Templates",
    },
    {
        key: TemplateTypes.interview,
        label: "Interview Kit Templates",
    },
];
export const newSectionItems = [
    {
        label: "Generate With Ai",
        key: "1",
    },
    {
        label: "Empty Section",
        key: "2",
    },
];

export const questionTypes = [
    {
        label: "with Yes/No answer",
        key: QuestionTypes.YES_NO,
    },
    {
        label: "with Free text answer",
        key: QuestionTypes.FREE_TEXT,
    },
];

export const blogs: IBlog[] = [
    {
        id: 1,
        cover: getImageUrl('coverBlog1'),
        heroCover: getImageUrl('heroBlog1Bg'),
        mobileCover: getImageUrl('mobileBlog1Bg'),
        title: "How AI is Redefining Recruitment: What HR Leaders Need to Know",
        publishedDate: "June 16,2025",
        timeToRead: "2 min",
        description: "Hiring the right talent at the right time is critical for every business. With the rise of AI in HR tech, the recruitment process is undergoing a massive transformation.",
        longDescription: "Hiring the right talent at the right time is critical for every business. With the rise of AI in HR tech, the recruitment process is undergoing a massive transformation. For HR leaders and hiring managers, understanding this shift is essential to stay competitive and attract top talent.",
        sections: [
            {
                title: "The Evolution of Recruitment",
                data: "Traditional hiring processes often rely heavily on manual screening and outdated systems. This leads to inefficiencies, unconscious biases, and missed opportunities. AI, however, brings speed, consistency, and intelligence to the process.",
            },
            {
                title: "What AI Can Do for Recruitment",
                data: [
                    {
                        title: 'Automated Resume Screening',
                        content: "AI tools can scan thousands of resumes in seconds, highlighting top candidates based on job requirements."
                    },
                    {
                        title: 'Predictive Analytics',
                        content: "Forecast candidate success and reduce turnover using data-driven models."
                    },
                    {
                        title: 'Bias Reduction',
                        content: "By anonymizing resumes and applying consistent criteria, AI can reduce human biases."
                    },
                    {
                        title: 'Faster Time-to-Hire',
                        content: "Automation accelerates scheduling, screening, and communication, saving HR teams hours per week."
                    }
                ],
                img: getImageUrl('blog1Diagram'),
                mobileImg: getImageUrl('mobileBlog1Diagram')
            },
            {
                title: "Real-World Benefits",
                subtitle: 'Companies using AI-powered tools like PeopleCQ report',
                data: [
                    {
                        title: '',
                        content: "45% reduction in time-to-hire"
                    },
                    {
                        title: '',
                        content: "30% increase in quality of hire"
                    },
                    {
                        title: '',
                        content: "60% improvement in candidate engagement"
                    }
                ],
            },
            {
                title: "How PeopleCQ Makes It Happen",
                subtitle: 'PeopleCQ uses smart automation to streamline the entire hiring journey',
                data: [
                    {
                        title: '',
                        content: "Intelligent candidate matching"
                    },
                    {
                        title: '',
                        content: "Seamless collaboration between recruiters and hiring managers"
                    },
                    {
                        title: '',
                        content: "Built-in compliance and structured interviews"
                    },
                    {
                        title: '',
                        content: "Streamline candidate comparison"
                    }
                ],
            }
        ],
        conclusion: "AI isn’t the future of recruitment, it’s the present. Equip your team with tools that make hiring smarter, not harder.",
        actionsSection: {
            title: "Ready to experience AI-powered hiring?",
            description: "Start your free trial now with PeopleCQ."
        }
    },
    {
        id: 2,
        cover: getImageUrl('coverBlog2'),
        heroCover: getImageUrl('heroBlog2Bg'),
        mobileCover: getImageUrl('coverBlog2'),
        title: "5 Hiring Challenges Faced by Growing Teams, And How to Solve Them",
        publishedDate: "June 16,2025",
        timeToRead: "2 min",
        description: "Scaling a business comes with growing pains—especially when it comes to hiring. If you’re struggling to find, screen, and retain the right people, you’re not alone.",
        longDescription: "Scaling a business comes with growing pains, especially when it comes to hiring. If you’re struggling to find, screen, and retain the right people, you’re not alone. Here are the top challenges fast-growing teams face, and how platforms like PeopleCQ can help.",
        sections: [
            {
                title: "Too Many Unqualified Applicants",
                data: [
                    {
                        title: 'The Problem',
                        content: "Job ads attract hundreds of resumes, but most don’t match the criteria."
                    },
                    {
                        title: 'The Solution',
                        content: "PeopleCQ’s smart filters and AI screening narrow the funnel instantly."
                    }
                ],
            },
            {
                title: "Slow Time-to-Hire",
                subtitle: '',
                data: [
                    {
                        title: 'The Problem',
                        content: "Long hiring cycles lead to losing top talent to competitors."
                    },
                    {
                        title: 'The Solution',
                        content: "Automated scheduling and candidate tracking speed up the process significantly."
                    }
                ],
            },
            {
                title: "Lack of Collaboration Between Hiring Teams",
                data: [
                    {
                        title: 'The Problem',
                        content: "Recruiters, HR, and hiring managers often work in silos."
                    },
                    {
                        title: 'The Solution',
                        content: "PeopleCQ offers a shared platform with structured workflows to keep everyone aligned."
                    }
                ],
                img: getImageUrl('blog2Img'),
                mobileImg: getImageUrl('blog2Img')
            },
            {
                title: "Poor Candidate Experience",
                data: [
                    {
                        title: 'The Problem',
                        content: "Unclear communication and delays hurt your brand."
                    },
                    {
                        title: 'The Solution',
                        content: "PeopleCQ streamlines candidate communication and feedback loops."
                    }
                ],
            },
            {
                title: "Difficulty Tracking Hiring Performance",
                data: [
                    {
                        title: 'The Problem',
                        content: "Without data, it’s hard to know what’s working."
                    },
                    {
                        title: 'The Solution',
                        content: "Track key hiring metrics in one dashboard: time-to-hire, cost-per-hire, and more."
                    }
                ],
            }
        ],
        conclusion: "Hiring shouldn’t be the bottleneck to your growth. Let technology do the heavy lifting while you focus on making the right choices.",
        actionsSection: {
            title: "Struggling with similar issues?",
            description: "Let PeopleCQ streamline your recruitment."
        }
    },
]

export const jobsPerPage = 10;
export const AISearchPerPage = 50;
export const candidatesPerPage = 50;
export const SearchcandidatesPerPage = 10;
export const currentSizeOfUploadingFile = 1; // The current size of uploading one file in MB
export const oneHour = 3600;
export const oneMinute = 60;
export const noDeptId = '-1'
export const interviewKitTemplates = 'Interview Kit Templates'
export const generalEvaluation = "General Evaluation"
export const attachments = 'attachments'
export const NoSectionTooltip = "You need to have at least one section to be able to publish your job."
// ENABLE ON PROD ONLY
export const clarityProdProjectId = 'riiyxumyd6'; // Your Clarity project ID
/* ENABLE ON DEV ONLY */
// export const clarityProdProjectId = 'rmhvdrye3h' // Your Clarity project ID

// meta pixel id for facebook pixel prod only
// ENABLE ON PROD ONLY
export const metaPixelIdProd = '8255751947787795';
/* ENABLE ON DEV ONLY */
// export const metaPixelIdProd = '';



export const landingPageContent: Record<string, ILandingPageContent> = {
    '/book-a-demo-a': {
        headline: 'Hire 2x Faster with Your AI Recruitment Partner',
        subHeadline: 'From job description to interview-ready candidates, effortlessly',
        cta: [CTAType.Book],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/book-a-demo-b': {
        headline: 'Hire 2x Faster with your AI Recruitment Partner for SMEs',
        subHeadline:
        'Within 7 minutes, your job description is written, candidates are ranked, and your top picks are ready for an interview.',
        cta: [CTAType.Book],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/book-a-demo-c': {
        headline: 'Tired of slow hiring? Meet your AI partner to hire 2x faster.',
        subHeadline:
            'From job description to interview-ready candidates in 7 minutes — PeopleCQ makes hiring smarter, faster, and stress-free.',
        cta: [CTAType.Book],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/start-your-free-trial-a': {
        headline: 'Hire 2x Faster with Your AI Recruitment Partner',
        subHeadline: 'From job description to interview-ready candidates, effortlessly',
        cta: [CTAType.Trial],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/start-your-free-trial-b': {
        headline: 'Hire 2x Faster with your AI Recruitment Partner for SMEs',
        subHeadline:
            'Within 7 minutes, your job description is written, candidates are ranked, and your top picks are ready for an interview.',
        cta: [CTAType.Trial],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/start-your-free-trial-c': {
        headline: 'Tired of slow hiring? Meet your AI partner to hire 2x faster.',
        subHeadline:
            'From job description to interview-ready candidates in 7 minutes — PeopleCQ makes hiring smarter, faster, and stress-free.',
        cta: [CTAType.Trial],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
    '/': {
        headline: 'Hire 2x Faster with Your AI Recruitment Partner',
        subHeadline: 'From job description to interview-ready candidates, effortlessly',
        cta: [CTAType.Book, CTAType.Trial],
        disclaimer: 'No card needed, just faster, smarter hiring from day one',
    },
};